<template>
  <div class="col table-responsive">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col" class="multi-line-header">Produktionsdatum</th>
          <th scope="col" class="multi-line-header">Operator</th>
          <th scope="col" class="multi-line-header">Batch Nummer</th>
          <th scope="col" class="multi-line-header">Ablaufdatum</th>
          <th scope="col" class="multi-line-header">Rückstellmuster</th>
          <th scope="col" class="multi-line-header">Folienname</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry, tableId) in entries" :key="tableId">
          <td>{{ entry.dateInProduction.replace("T", " ") }}</td>
          <td>{{ entry.firstname }} {{ entry.lastname }}</td>
          <td>{{ entry.foilbatch }}</td>
          <td
            v-if="checkDate(entry.dateInProduction, entry.foilExpirationDate)"
          >
            {{ entry.foilExpirationDate.split("T")[0] }}
          </td>
          <td class="expired" v-else>
            {{ entry.foilExpirationDate.split("T")[0] }}
          </td>
          <td v-if="entry.isFoilSampleStored">Ja</td>
          <td v-else>Nein</td>
          <td>{{ entry.name }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from "vue";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});

const entries = ref([]);

const checkDate = (dateOne, dateTwo) => {
  return Date.parse(dateOne) < Date.parse(dateTwo);
};

const fetchData = async (url) => {
  try {
    const { data } = await axios.get(url);
    entries.value = Array.isArray(data) ? data : [];
    console.log(entries.value);
  } catch (error) {
    console.log(error.message);
  }
};

onMounted(() => {
  fetchData(props.url);
});
</script>

<style scoped>
@media (max-width: 768px) {
  th {
    white-space: normal;
    word-wrap: break-word;
  }
}

.expired {
  color: darkorange !important;
}
</style>
